import gql from 'not-graphql-tag';

export const GET_TOD_ENROLLMENT_STATUS_QUERY = gql`
  query getAccountDetails($params: AccountDetailParams!) {
    getAccountDetails(params: $params) {
      timeOfDayInfo {
        enrollmentStatus
      }
    }
  }
`;
